import { render, staticRenderFns } from "./LabelHeader.vue?vue&type=template&id=51cc2ac8&scoped=true&"
import script from "./LabelHeader.vue?vue&type=script&lang=js&"
export * from "./LabelHeader.vue?vue&type=script&lang=js&"
import style0 from "./LabelHeader.vue?vue&type=style&index=0&id=51cc2ac8&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51cc2ac8",
  null
  
)

export default component.exports